var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"see-more-div"},[_c('div',{staticClass:"see-more",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    查看更多 >>\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }